module.exports = __webpack_public_path__ + "static/media/exhibition.515863a3.svg";